import Lightbox from './components/Lightbox';

export default Lightbox;
